import { useState, useEffect } from 'react';
import Header from './include/header';
import Footer from './include/footer';
import UserLeftPanel from './include/UserLeftPanel';
import { useNavigate,useParams } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Global from '../APIConfig';
import  axios from "axios";
import AuthUser from "../AuthUser";
import MainLoader from "./Loaders/MainLoader";

function AdminProfile() {
    let navigate = useNavigate();
    const {UniqueId} = useParams();
    const {headers1,headers2,logout}=AuthUser();
    const [Name, setName] = useState('');
    const [Email, setEmail] = useState('');
    const [Loading, setLoading] = useState(true);
    const [BtnLoading, setBtnLoading] = useState(false);
    const [Password, setPassword] = useState('');
    const [ConfirmPassword, setConfirmPassword] = useState('');
    const [profileimg, setProfileimg] = useState('');
    const [oldprofileimg, setOldProfileimg] = useState('');
    useEffect(()=>{
        GetStaffDetail(UniqueId);
    },[]);
    const GetStaffDetail=(id)=>{
        axios({
            method: 'post',
            url: Global.baseUrl+'GetAdminDetail',
            headers:headers1,
            data: {
                UniqueId:id
            }
          })
          .then(function (response) {
            if(response.data.status == 200)
            {
                var data=response.data.value;
                setName(data.name);
                setEmail(data.email);
                setOldProfileimg(data.profile_image);
            }
          })
          .catch(function (error) {
            setBtnLoading(false);
            if(error.response.status==401){
                toast.error(error.response.statusText);
                logout();
                navigate('/');
                window.location.reload();
            }
          });
          setLoading(false);
    }
    const handleSubmit=()=>{
        if(Name==""){
            toast.warning('Name is Required');
        }
        else if(Email==""){
            toast.warning('Email is Required');
        }
        else{
            setBtnLoading(true);
            axios({
                method: 'post',
                url: Global.baseUrl+'EditAdmin',
                headers:headers2,
                data: {
                    UniqueId:UniqueId,
                    Name:Name,
                    Email:Email,
                    profile_image:profileimg,
                    oldprofile_image:oldprofileimg
                }
              })
              .then(function (response) {
                if(response.data.status == 200)
                {
                    toast.success(response.data.message);
                }else{
                    toast.warning(response.data.message);
                }
                setBtnLoading(false);
              })
              .catch(function (error) {
                setBtnLoading(false);
                if(error.response.status==401){
                    toast.error(error.response.statusText);
                    logout();
                    navigate('/');
                    window.location.reload();
                }
              });
        }
    }
    const handlePassSubmit=()=>{
        if(Password==""){
            toast.warning('Password is Required');
        }
        else if(ConfirmPassword==""){
            toast.warning('Confirm Password is Required');
        }
        else if(Password!=ConfirmPassword){
            toast.warning('Password And Confirm Password Must Be Same');
        }
        else{
            setBtnLoading(true);
            axios({
                method: 'post',
                url: Global.baseUrl+'AdminChangePassword',
                headers:headers1,
                data: {
                    UniqueId:UniqueId,
                    Password:Password
                }
              })
              .then(function (response) {
                if(response.data.status == 200)
                {
                    toast.success(response.data.message);
                    setTimeout(() => {
                        navigate('/Admin-Dash');
                      }, 1000);
                }else{
                    toast.warning(response.data.message);
                }
                setBtnLoading(false);
              })
              .catch(function (error) {
                setBtnLoading(false);
                if(error.response.status==401){
                    toast.error(error.response.statusText);
                    logout();
                    navigate('/');
                    window.location.reload();
                }
              });
        }
    }

    return(
        <>
            <UserLeftPanel/>
            <main className='home-section'>
                <Header/>
                <ToastContainer/>
                {Loading==true?<MainLoader/>:
                <>
                <section className="left_sub_menu">
                    <div className="row">
                        <div className="col-12 col-md">
                            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                                <div className="d-block mb-4 mb-md-0">
                                    <nav aria-label="breadcrumb" className="d-none d-md-inline-block">
                                        <ol className="breadcrumb breadcrumb-dark breadcrumb-transparent">
                                            <li className="breadcrumb-item">
                                                <a href="/Admin-Dash">
                                                <i className="bx bx-home text-primary-400 fs-6"></i>
                                                </a>
                                            </li>
                                            <li className="breadcrumb-item active" aria-current="page">Edit Admin</li>
                                        </ol>
                                    </nav>
                                    <div className="d-flex justify-content-between">
                                        <div className="">
                                            <button className="btn btn_nav btn-sm" type="button" onClick={() => navigate(-1)}>
                                            <i className="bx bx-arrow-back "></i>
                                            </button>
                                        </div>
                                        <div className="ps-2 ">
                                            <h2 className="h4">Edit Admin</h2>
                                        </div>
                                    </div>
                                </div>
                                <div className="btn-toolbar mb-2 mb-md-0">
                                </div>
                            </div>

                            <div className="card">
                                <div className="card-body">
                                <h6>Edit Admin</h6>
                                    <div className="row">
                                        <div className="col-12 mb-3 mt-4">
                                            <div className="row">
                                                <div className="col-4 mb-3">
                                                    <label for="" className="form-label">Name: <span className="text-danger">*</span></label>
                                                    <input type="text" className="form-control" value={Name} onChange={(e)=>setName(e.target.value)} placeholder="Please Enter Name" />
                                                </div>
                                                <div className="col-4 mb-3">
                                                    <label for="" className="form-label">Email: <span className="text-danger">*</span></label>
                                                    <input type="email" className="form-control" value={Email} onChange={(e)=>setEmail(e.target.value)} placeholder="Please Enter Email" />
                                                </div>
                                                <div className="col-4 mb-3">
                                                    <label for="" className="form-label">Image: <span className="text-danger">*</span></label>
                                                    <input type="file" className="form-control" onChange={(e)=>setProfileimg(e.target.files[0])} placeholder="Please Select File" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {BtnLoading==false?
                                    <div className="d-grid col-md-2 mt-2">
                                        <button className="btn btn-primary" onClick={()=>handleSubmit()}>Submit</button>
                                    </div>
                                    :
                                    <div className="d-grid col-md-2 mt-2">
                                        <a href="" className="btn btn-primary btn-block"> <div class="spinner-border text-light" role="status"><span class="visually-hidden">Loading...</span></div></a>
                                    </div>
                                    }
                                </div>
                            </div>

                        </div>
                    </div>
                </section>
                <section className="left_sub_menu pt-2">
                    <div className="card">
                        <div className="card-body">
                            <h6>Change Admin Password</h6>
                            <div className="row">
                                <div className="col-12 mb-3 mt-4">
                                    <div className="row">
                                        <div className="col-4 mb-3">
                                            <label for="" className="form-label">Password: <span className="text-danger">*</span></label>
                                            <input type="password" className="form-control" onChange={(e)=>setPassword(e.target.value)} placeholder="Please Enter Password" />
                                        </div>
                                        <div className="col-4 mb-3">
                                            <label for="" className="form-label">Confirm Password: <span className="text-danger">*</span></label>
                                            <input type="password" className="form-control" onChange={(e)=>setConfirmPassword(e.target.value)} placeholder="Please Enter Confirm Password" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {BtnLoading==false?
                            <div className="d-grid col-md-2 mt-2">
                                <button className="btn btn-primary" onClick={()=>handlePassSubmit()}>Submit</button>
                            </div>
                            :
                            <div className="d-grid col-md-2 mt-2">
                                <a href="" className="btn btn-primary btn-block"> <div class="spinner-border text-light" role="status"><span class="visually-hidden">Loading...</span></div></a>
                            </div>
                            }
                        </div>
                    </div>
                </section>
            </>
                }
                <Footer/>
            </main>
        </>
    )
}
export default AdminProfile;